import { render } from "./DingHistorical.vue?vue&type=template&id=aadb35a4&scoped=true"
import script from "./DingHistorical.vue?vue&type=script&lang=js"
export * from "./DingHistorical.vue?vue&type=script&lang=js"

import "./DingHistorical.vue?vue&type=style&index=0&id=aadb35a4&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aadb35a4"]])

export default __exports__